export default __webpack_public_path__ + "static/media/img_13.a31819eb.jpg";